import React, { useEffect, useState } from 'react';
import { Box, CardContent, Typography } from '@material-ui/core';
import { colorsGraphsArr } from 'components/Charts/Colors';
// import styles from './Toolbox.module.scss';
import {
    SGSBadge,
    SGSCardHeader,
    SGSCardFooter,
    SGSTextButton,
    SGSButton,
    CustomButton,
    SGSTab,
    SGSTabPanel,
    SGSTabs,
    SGSCopyButton,
    SGSMenuLinkAnimated,
    SGSMenuItem,
    SGSCard,
    SGSIconBadge,
    SGSMiniCard,
    SGSColoredCard,
    SGSDataGrid,
} from '../../components';
import { useTranslation } from 'react-i18next';
import IconSalaries from '../../assets/salaries.svg';
import IconContact from '../../assets/contact.svg';
import IconRecherche from '../../assets/recherche.svg';
import FileOk from '../../assets/file-ok.svg';
import FileWaiting from '../../assets/file-waiting.svg';
import { GridRowsProp } from '@mui/x-data-grid';
import { useDemoData, GridData } from '@material-ui/x-grid-data-generator';

type Props = {};

function loadServerRows(page: number, data: GridData): Promise<any> {
    return new Promise<any>((resolve) => {
        setTimeout(() => {
            resolve(data.rows.slice(page * 5, (page + 1) * 5));
        }, Math.random() * 500 + 100); // simulate network latency
    });
}

const Toolbox: React.FC<Props> = () => {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = useState(0);

    const handleChangeTab = (_event: React.ChangeEvent<{}>, newValue: number) => {
        setTabValue(newValue);
    };

    const { data } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 98,
        maxColumns: 6,
    });
    const [tablePage, setTablePage] = useState(0);
    const [tableRows, setTableRows] = useState<GridRowsProp>([]);
    const [tableLoading, setTableLoading] = useState<boolean>(false);

    const handlePageChange = (page: number) => {
        setTablePage(page);
    };

    useEffect(() => {
        let active = true;

        (async () => {
            setTableLoading(true);
            const newRows = await loadServerRows(tablePage, data);

            if (!active) {
                return;
            }

            setTableRows(newRows);
            setTableLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [tablePage, data]);

    colorsGraphsArr();

    return (
        <Box>
            <Box>
                <Typography variant="h2">{t('toolbox.heading.title')}</Typography>
                <Typography variant="h1">{t('toolbox.heading.label')} h1</Typography>
                <Typography variant="h2">{t('toolbox.heading.label')} h2</Typography>
                <Typography variant="h3">{t('toolbox.heading.label')} h3</Typography>
                <Typography variant="h4">{t('toolbox.heading.label')} h4</Typography>
                <Typography variant="h5">{t('toolbox.heading.label')} h5</Typography>
                <Typography variant="h6">{t('toolbox.heading.label')} h6</Typography>
            </Box>
            <Box>
                <SGSCard title="Titre de la carte">
                    {/* <SGSCardHeader title="Titre" /> */}
                    {/* <SGSCard.Title title="title"></SGSCard.Title> */}
                    <SGSCardHeader title="header"></SGSCardHeader>
                    <CardContent>{t('toolbox.content.label')}</CardContent>
                    <SGSCardFooter>{t('toolbox.footer.label')}</SGSCardFooter>
                </SGSCard>
                <SGSMiniCard title="Title" className="mt-2">
                    <SGSColoredCard
                        color="blue"
                        title={t('toolbox.card.processing')}
                        image={FileOk}
                        alt="Traitement"
                        count="50"
                    >
                        {t('toolbox.card.blue')}
                    </SGSColoredCard>
                    <SGSColoredCard
                        color="orange"
                        title={t('toolbox.card.waiting')}
                        image={FileWaiting}
                        alt="Traitement"
                        count="25"
                        className="mt-2"
                    >
                        {t('toolbox.card.orange')}
                    </SGSColoredCard>
                </SGSMiniCard>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.dataGrid.processing')}</Typography>
                <Box>
                    <SGSCard className="w-100">
                        <SGSCardHeader title="Titre" />
                        <CardContent>
                            <SGSDataGrid
                                noHeader
                                hideFooterSelectedRowCount
                                disableSelectionOnClick
                                pageSize={5}
                                rowCount={data.rows.length}
                                paginationMode="server"
                                onPageChange={handlePageChange}
                                loading={tableLoading}
                                rows={tableRows}
                                columns={data.columns}
                            />
                        </CardContent>
                        <SGSCardFooter>{t('toolbox.footer.label')}</SGSCardFooter>
                    </SGSCard>
                </Box>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.buttons.label')}</Typography>
                <CustomButton
                    className="mr-4"
                    label={t('affiliations.contrat.bia.valider')}
                    icon="fa-check-circle"
                    onClick={() => {}}
                />
            </Box>
            <Box className="d-flex flex-column">
                <Typography variant="h2">{t('toolbox.buttons.label')}</Typography>
                <Box>
                    <SGSButton color="primary" variant="outlined">
                        Test
                    </SGSButton>
                    <SGSButton color="primary" variant="contained">
                        Test
                    </SGSButton>
                    {/* <SGSTextButton color="blue" onClick={() => {}}>
                        {t('toolbox.buttons.contained.blue')}
                    </SGSTextButton> */}
                </Box>
                <Box>
                    <SGSButton color="primary" variant="outlined">
                        Test
                    </SGSButton>
                    <SGSButton color="primary" variant="outlined">
                        Test
                    </SGSButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton color="orange" onClick={() => {}}>
                        {t('toolbox.buttons.contained.orange')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton color="blue" variant="outlined" onClick={() => {}}>
                        {t('toolbox.buttons.outlined.blue')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton color="midblue" variant="outlined" onClick={() => {}}>
                        {t('toolbox.buttons.outlined.midblue')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton color="orange" variant="outlined" onClick={() => {}}>
                        {t('toolbox.buttons.outlined.orange')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton
                        color="blue"
                        variant="outlined"
                        size="large"
                        icon="far fa-check-circle"
                        onClick={() => {}}
                    >
                        {t('toolbox.buttons.outlined.blue')} - {t('toolbox.large.label')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton
                        color="midblue"
                        variant="outlined"
                        size="large"
                        icon="far fa-check-circle"
                        onClick={() => {}}
                    >
                        {t('toolbox.buttons.outlined.midblue')} - {t('toolbox.large.label')}
                    </SGSTextButton>
                </Box>
                <Box className="mt-2">
                    <SGSTextButton
                        color="orange"
                        variant="outlined"
                        size="large"
                        icon="far fa-times-circle"
                        onClick={() => {}}
                    >
                        {t('toolbox.buttons.outlined.orange')} - {t('toolbox.large.label')}
                    </SGSTextButton>
                </Box>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.badges.label')}</Typography>
                <SGSBadge color="blue">25</SGSBadge>
                <SGSBadge color="orange">25</SGSBadge>
                <SGSBadge color="gray">25</SGSBadge>
                <SGSBadge color="blue" size="large">
                    50
                </SGSBadge>
                <SGSBadge color="orange" size="large">
                    50
                </SGSBadge>
                <SGSBadge color="gray" size="large">
                    50
                </SGSBadge>
                <SGSBadge color="darkblue" size="large">
                    50
                </SGSBadge>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.iconBadges.label')}</Typography>
                <SGSIconBadge image="a" color="green" />
                <SGSIconBadge image="a" color="orange" />
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.tabs.label')}</Typography>
                <Box className="d-flex">
                    <Box>
                        <SGSTabs value={tabValue} onChange={handleChangeTab}>
                            <SGSTab label={t('toolbox.tabs.itemOne')} />
                            <SGSTab label={t('toolbox.tabs.itemTwo')} />
                        </SGSTabs>
                        <SGSTabPanel value={tabValue} index={0}>
                            {t('toolbox.tabs.itemOne')}
                        </SGSTabPanel>
                        <SGSTabPanel value={tabValue} index={1}>
                            {t('toolbox.tabs.itemTwo')}
                        </SGSTabPanel>
                    </Box>
                    <SGSCopyButton value="TEST" />
                </Box>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.menuLinkAnimated.label')}</Typography>
                <SGSMenuLinkAnimated image={IconContact} alt="contact us">
                    {t('toolbox.menuLinkAnimated.contact')}
                </SGSMenuLinkAnimated>
                <SGSMenuLinkAnimated image={IconRecherche} alt="search" active className="mt-2">
                    {t('toolbox.menuLinkAnimated.search')}
                </SGSMenuLinkAnimated>
            </Box>
            <Box className="d-flex flex-column">
                <Typography variant="h2">{t('toolbox.menuLink.label')}</Typography>
                <SGSMenuItem image={IconSalaries} alt="salaries">
                    {t('toolbox.menuLink.title')}
                </SGSMenuItem>
                <SGSMenuItem image={IconSalaries} alt="salaries" active>
                    {t('toolbox.menuLink.title')}
                </SGSMenuItem>
            </Box>
            <Box>
                <Typography variant="h2">{t('toolbox.coulors.label')}</Typography>
                {/* {COLORS && (
                    <>
                        {COLORS.map((e) => {
                            return <Box style={{ width: '40px', height: '40px', background: e, float: 'left' }}></Box>;
                        })}
                    </>
                )} */}
            </Box>
        </Box>
    );
};

export default Toolbox;
